import styled from 'styled-components';


export const ContentBox = styled.div`
    background-color: rgb(255, 255, 255);
    color: rgb(38, 38, 39);
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 4px;
    padding: 32px;
    margin-bottom: 15px;
`

export const ProfileWrap = styled.div`
    margin: 0 auto;
    width: 90%;
    max-width: 1100px;

    @media (max-width: 890px) {
        padding-top: 50px;
    }
`

export const NameBox = styled.div`
    display: flex;

`

export const ProfileOverall = styled.div`
    background-color: #FAFAFA;
    width: 100%;
    min-height: calc(100vh - 60px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding-top: 15px;
    margin-left: 96px;

    @media (max-width: 1023px) {
        margin-left: 0px;
    }
`

export const SectionHeader = styled.h2`
    font-size: 1.3rem;
    font-weight: 500;
    font-family: 'Jarkarta', sans-serif;
    margin-bottom: 0.5rem;
`

export const UserName = styled.h1`
    font-size: 1.6rem;
    font-weight: 500;
    font-family: 'Jarkarta', sans-serif;
`

export const SocialLinks = styled.div`
    display: flex;
    flex-wrap: wrap;

    > * {
        margin-right: 0.75rem;
    }
`

export const SmallFancyBold = styled.p`
    font-weight: 500;
    font-family: 'Jarkarta', sans-serif;
    font-size: 1rem;
`

export const PhotoLabel = styled.label`
    padding: 7px 12px;
    &:hover {
        cursor: pointer;
    }
`